"use client";

import { FAQ } from "@/components/faq";
import { AnimatedSection } from "./motion";

export function FAQSection() {
  return (
    <AnimatedSection id="faq" className="container space-y-6 py-16 md:py-24 lg:py-32">
      <div className="mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center">
        <span className="inline-flex items-center rounded-full bg-slate-100 px-4 py-1 text-xs font-semibold text-slate-600 ring-1 ring-inset ring-slate-200">
          FAQ
        </span>
        <h2 className="font-heading text-3xl leading-[1.1] sm:text-3xl md:text-6xl">
          Frequently asked questions
        </h2>
        <p className="max-w-[85%] leading-relaxed text-muted-foreground sm:text-lg">
          Everything you need to know about BotByte AI.
        </p>
        <div className="w-full text-left mt-4">
          <FAQ />
        </div>
      </div>
    </AnimatedSection>
  );
}
